import { getDateFormatted } from '@shared/utils'
import {
  SRBigCalendarEventWeekBlockStyle,
  SRBigCalendarEventWeekStyle,
} from './styles'

export const SRBigCalendarEventWeek = ({ event = {} }) => {
  const { start, end, isTravelTime } = event

  if (!start || !end) return

  const startDate = getDateFormatted(start, 'HH:mm')
  const endDate = getDateFormatted(end, 'HH:mm')

  if (isTravelTime) {
    return (
      <SRBigCalendarEventWeekStyle>
        <SRBigCalendarEventWeekBlockStyle>
          <div className="text-center">
            <span>{startDate}</span>
            <span> - </span>
            <span>{endDate}</span>
          </div>
        </SRBigCalendarEventWeekBlockStyle>
      </SRBigCalendarEventWeekStyle>
    )
  }

  return (
    <SRBigCalendarEventWeekStyle>
      <SRBigCalendarEventWeekBlockStyle>
        <div className="text-center">
          <span>{startDate}</span>
          <span> - </span>
          <span>{endDate}</span>
        </div>
      </SRBigCalendarEventWeekBlockStyle>
    </SRBigCalendarEventWeekStyle>
  )
}